(function () {
  if (!window.__gtmShop || !window.__gtmShop.enabled) return;

  window.dataLayer = window.dataLayer || [];

  var config = window.__gtmShop;
  var currency = config.currency || 'EUR';
  var cartSnapshot = null;
  var pendingRemovals = {};

  function toCurrency(value) {
    return Math.round(Number(value || 0)) / 100;
  }

  function normalizeItem(item, index) {
    if (!item) return null;

    var normalized = {
      item_id: String(item.item_id || item.sku || item.variant_id || item.id || ''),
      item_name: item.item_name || item.product_title || item.title || '',
      price: toCurrency(item.price),
      quantity: Number(item.quantity || 1)
    };

    var variantTitle = item.item_variant || item.variant_title;
    if (variantTitle && variantTitle !== 'Default Title') {
      normalized.item_variant = variantTitle;
    }

    if (item.item_brand || item.vendor) normalized.item_brand = item.item_brand || item.vendor;
    if (item.item_category || item.product_type) normalized.item_category = item.item_category || item.product_type;
    if (item.item_list_name) normalized.item_list_name = item.item_list_name;
    if (item.item_list_id) normalized.item_list_id = item.item_list_id;
    if (typeof index === 'number') normalized.index = index;

    return normalized;
  }

  function normalizeItems(items) {
    return (items || []).map(function (item, index) {
      return normalizeItem(item, index);
    }).filter(Boolean);
  }

  function ecommerceValue(items) {
    return items.reduce(function (sum, item) {
      return sum + (item.price * item.quantity);
    }, 0);
  }

  function clearEcommerce() {
    window.dataLayer.push({ ecommerce: null });
  }

  function pushEcommerceEvent(eventName, ecommerce, extra) {
    clearEcommerce();

    var payload = Object.assign({
      event: eventName,
      ecommerce: Object.assign({ currency: currency }, ecommerce || {})
    }, extra || {});

    window.dataLayer.push(payload);
  }

  function pushConsentUpdate(granted) {
    if (typeof window.__tepoApplyGtmConsent === 'function') {
      window.__tepoApplyGtmConsent(granted);
      return;
    }

    window.dataLayer.push({
      event: 'consent_update',
      analytics_storage: granted ? 'granted' : 'denied',
      ad_storage: granted ? 'granted' : 'denied',
      ad_user_data: granted ? 'granted' : 'denied',
      ad_personalization: granted ? 'granted' : 'denied',
      personalization_storage: granted ? 'granted' : 'denied'
    });

    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: granted ? 'granted' : 'denied',
        ad_storage: granted ? 'granted' : 'denied',
        ad_user_data: granted ? 'granted' : 'denied',
        ad_personalization: granted ? 'granted' : 'denied',
        personalization_storage: granted ? 'granted' : 'denied'
      });
    }
  }

  function mapCartJsItem(item, index) {
    return normalizeItem({
      item_id: item.sku || item.variant_id || item.id,
      item_name: item.product_title || item.title,
      item_variant: item.variant_title,
      item_brand: item.vendor,
      item_category: item.product_type,
      price: item.price,
      quantity: item.quantity || 1
    }, index);
  }

  function rememberCart(cart) {
    if (!cart || !cart.items) return;
    cartSnapshot = cart.items.reduce(function (map, item) {
      map[item.key] = item;
      return map;
    }, {});
  }

  function getLineItemFromDom(lineItemElement) {
    if (!lineItemElement) return null;

    var quantityInput = lineItemElement.querySelector('[data-line-key]');
    var lineKey = quantityInput ? quantityInput.getAttribute('data-line-key') : null;
    var quantity = quantityInput ? Number(quantityInput.value || 1) : 1;
    var titleEl = lineItemElement.querySelector('.bold, .reversed-link');
    var title = titleEl ? titleEl.textContent.trim() : '';

    if (lineKey && cartSnapshot && cartSnapshot[lineKey]) {
      return mapCartJsItem(cartSnapshot[lineKey]);
    }

    return normalizeItem({
      item_id: lineKey || title,
      item_name: title,
      price: 0,
      quantity: quantity
    });
  }

  function firePageEvent() {
    if (!config.pageEvent || !config.ecommerce) return;

    if (config.pageEvent === 'purchase') {
      var orderId = config.ecommerce.transaction_id;
      var storageKey = 'gtm_purchase_' + orderId;

      try {
        if (sessionStorage.getItem(storageKey)) return;
        sessionStorage.setItem(storageKey, '1');
      } catch (error) {
        // Safari private mode
      }
    }

    var items = normalizeItems(config.ecommerce.items || []);
    var ecommerce = {
      currency: config.ecommerce.currency || currency,
      value: config.ecommerce.value != null ? toCurrency(config.ecommerce.value) : ecommerceValue(items),
      items: items
    };

    if (config.pageEvent === 'view_item_list') {
      ecommerce.item_list_id = config.ecommerce.item_list_id;
      ecommerce.item_list_name = config.ecommerce.item_list_name;
    }

    if (config.pageEvent === 'purchase') {
      ecommerce.transaction_id = config.ecommerce.transaction_id;
      ecommerce.tax = toCurrency(config.ecommerce.tax);
      ecommerce.shipping = toCurrency(config.ecommerce.shipping);
    }

    if (config.ecommerce.search_term) {
      window.dataLayer.push({
        event: 'search',
        search_term: config.ecommerce.search_term
      });
    }

    pushEcommerceEvent(config.pageEvent, ecommerce);
  }

  function initConsent() {
    var applyConsent = function (granted) {
      if (window.__tepoGtmAnalyticsConsent === (granted ? 'granted' : 'denied')) return;
      pushConsentUpdate(granted);
    };

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-action="accept"], [data-action="decline"]');
      if (!button) return;
      applyConsent(button.getAttribute('data-action') === 'accept');
    });

    if (window.__tepoGtmAnalyticsConsent === 'granted') return;

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{
        name: 'consent-tracking-api',
        version: '0.1',
        onLoad: function () {
          var privacy = window.Shopify.customerPrivacy;
          if (!privacy) return;

          if (typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed()) {
            applyConsent(true);
          } else if (typeof privacy.shouldShowBanner === 'function' && !privacy.shouldShowBanner()) {
            applyConsent(true);
          }
        }
      }]);
    }
  }

  function initDynamicEvents() {
    document.addEventListener('variant:add', function (event) {
      var items = (event.detail.items || []).map(mapCartJsItem).filter(Boolean);
      if (!items.length) return;

      pushEcommerceEvent('add_to_cart', {
        value: ecommerceValue(items),
        items: items
      });

      rememberCart(event.detail.cart);
    });

    document.addEventListener('cart:change', function (event) {
      rememberCart(event.detail.cart);
    });

    document.addEventListener('line-item:will-change', function (event) {
      var lineItem = event.target.closest('line-item');
      var quantityInput = lineItem && lineItem.querySelector('[data-line-key]');
      if (!quantityInput) return;

      pendingRemovals[quantityInput.getAttribute('data-line-key')] = {
        previousQuantity: Number(quantityInput.value || 0),
        item: getLineItemFromDom(lineItem)
      };
    });

    document.addEventListener('line-item:change', function (event) {
      var lineItem = event.target.closest('line-item');
      var quantityInput = lineItem && lineItem.querySelector('[data-line-key]');
      var lineKey = quantityInput ? quantityInput.getAttribute('data-line-key') : null;
      var pending = lineKey ? pendingRemovals[lineKey] : null;
      var quantity = Number(event.detail.quantity || 0);

      if (!pending || !pending.item) return;

      var removedQuantity = pending.previousQuantity - quantity;
      if (removedQuantity <= 0) {
        delete pendingRemovals[lineKey];
        return;
      }

      var item = Object.assign({}, pending.item, { quantity: removedQuantity });

      pushEcommerceEvent('remove_from_cart', {
        value: item.price * item.quantity,
        items: [item]
      });

      delete pendingRemovals[lineKey];
    });

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href*="/cart/change"]');
      if (link) {
        try {
          var removeUrl = new URL(link.href, window.location.origin);
          var targetQuantity = Number(removeUrl.searchParams.get('quantity'));
          var lineKey = removeUrl.searchParams.get('id');

          if (targetQuantity === 0 && lineKey && cartSnapshot && cartSnapshot[lineKey]) {
            var removedItem = mapCartJsItem(cartSnapshot[lineKey]);
            pushEcommerceEvent('remove_from_cart', {
              value: removedItem.price * removedItem.quantity,
              items: [removedItem]
            });
          }
        } catch (error) {
          // Ignore malformed remove URLs.
        }
      }

      var checkoutTarget = event.target.closest(
        '[name="checkout"], a[href*="checkout"], .shopify-payment-button, .additional-checkout-buttons button, .additional-checkout-buttons a'
      );

      if (!checkoutTarget) return;

      var items = [];

      if (config.pageType === 'cart' && config.ecommerce && config.ecommerce.items) {
        items = normalizeItems(config.ecommerce.items);
      } else if (cartSnapshot) {
        items = Object.keys(cartSnapshot).map(function (key, index) {
          return mapCartJsItem(cartSnapshot[key], index);
        });
      }

      pushEcommerceEvent('begin_checkout', {
        value: ecommerceValue(items),
        items: items
      });
    }, true);
  }

  function bootstrapCart() {
    if (window.fetchCart && typeof window.fetchCart.then === 'function') {
      window.fetchCart.then(function (cart) {
        rememberCart(cart);
      }).catch(function () {
        // Ignore cart bootstrap failures.
      });
      return;
    }

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
      .then(function (response) { return response.json(); })
      .then(rememberCart)
      .catch(function () {
        // Ignore cart bootstrap failures.
      });
  }

  initConsent();
  firePageEvent();
  initDynamicEvents();
  bootstrapCart();
})();
